import React from 'react'
import PropTypes from 'prop-types'

import { useSelector, useDispatch } from 'react-redux'

import styled from '@emotion/styled'

import { selectProductCtas } from '../../../../flux/selectors/product'
import { selectUserNearestStoreId } from '../../../../flux/selectors/user'
import { selectViewMode } from '../../../../flux/selectors/layout'
import { uxEvent } from '../../../../flux/actions/ux'
import { CAROUSEL_VIEW_MODE, CONTEXT_DRAWER } from '../../../../helpers/const'

import ProductCta from './ProductCta'

const CtasWrapper = styled.div(({ previewMode, viewMode, theme: { spaces, breakpoints } }) => {
  const isCarousel = viewMode === CAROUSEL_VIEW_MODE
  let flexDirection = 'column'
  if (previewMode || isCarousel) flexDirection = 'row'

  return {
    display: 'flex',
    flexDirection,
    margin: '0 auto',
    maxWidth: spaces.default * 31.5,
    paddingTop: spaces.default,
    paddingBottom: 0,
    width: '100%',
    '& *:not(:last-child)': (
      flexDirection === 'row'
        ? { marginRight: spaces.default / 2 }
        : { marginBottom: spaces.default / 2 }
    ),
    [`@media (min-width: ${breakpoints.medium})`]: (
      !isCarousel
        ? {
          flexDirection: 'column',
          '& *:not(:last-child)': {
            marginBottom: spaces.default / 2,
          },
        } : {}
    ),
  }
})

const ProductCtas = ({ productId, previewMode }) => {
  const dispatch = useDispatch()
  const viewMode = useSelector(selectViewMode)
  const nearestStoreId = useSelector(selectUserNearestStoreId)
  const productCtas = useSelector(selectProductCtas(productId, nearestStoreId, { previewMode }))
  const onCtaClick = ctaType => {
    dispatch(uxEvent({
      name: 'click',
      target: `ProductDetail/${ctaType}`,
      params: {
        productId,
        context: CONTEXT_DRAWER,
      },
    }))
  }

  return productCtas && productCtas.length ? (
    <CtasWrapper data-test="ProductDetailsCtas" previewMode={previewMode} viewMode={viewMode}>
      {productCtas.map(cta => (
        <ProductCta
          key={cta.type}
          ctaType={cta.type}
          href={cta.href}
          target={cta.target}
          text={cta.text}
          toggleText={cta.toggleText}
          color={cta.color}
          backgroundColor={cta.backgroundColor}
          borderColor={cta.borderColor}
          hasIcon={cta.hasIcon}
          hasToggleIcon={cta.hasToggleIcon}
          onClick={onCtaClick}
        />
      ))}
    </CtasWrapper>
  ) : null
}

ProductCtas.propTypes = {
  productId: PropTypes.string.isRequired,
  previewMode: PropTypes.bool,
}

ProductCtas.defaultProps = {
  previewMode: false,
}

ProductCtas.displayName = 'ProductCtas'
ProductCtas.whyDidYouRender = true

export default React.memo(ProductCtas)
